/**
 * Registering widget in Duda
 * @param {string} name - The name of the widget
 * @param {callback} init - The exported function that executed on widget initialization
 * @param {callback} clean - The exported function that executed on widget destruction
 * 
 * For code that is written without a build system (or that is not built as amd),
 * some additional properties should be passed (namely, amd and name):
 * The App should expose init and clean as well.
 * 
 * Docs: https://developer.duda.co/docs/external-js-apps
 * 
 * Example: https://github.com/DudaDev/react-widget-demo/blob/no-amd/src/index.js
 */
export function registerWidget(name, init, clean) {
  (function (global) {
    // Added check to prevent errors in demo
    if (!global || !global.dmAPI) return;

    global.dmAPI.registerExternalWidget(name, {
      init,
      clean
    })
  })(window)
}
